export const ProcessTypeEnum = {

    CASH_IN_ACCOUNT_CHARGE_CORPORATE:"شارژ شرکت",
    CASH_IN_ACCOUNT_CHARGE_USER:"شارژ شخصی کاربر",
    CASH_OUT_GYMPIN:"خروج وجه خصوصی",
    CASH_OUT_CORPORATE:"خروج وجه شرکت",
    CASH_OUT_PERSONAL:"خروج وجه شخص",
    CASH_OUT_PLACE:"خروج درامد مرکز",
    TRA_INCREASE_USER_NW_CARD:"افزایش اعتبار با کارت",
    TRA_INCREASE_PERSONNEL_CREDIT_NW_MULTIPLE:"افزایش اعتبار غیر قابل برداشت",
    TRA_INCREASE_PERSONNEL_CREDIT_SINGLE:"افزایش اعتبار تکی",
    TRA_INCREASE_PERSONNEL_CREDIT_MULTIPLE:"افزایش اعتبار گروهی",
    TRA_DECREASE_PERSONNEL_CREDIT_SINGLE:"کاهش اعتبار تکی",
    TRA_DECREASE_PERSONNEL_CREDIT_MULTIPLE:"کاهش اعتبار گروهی",
    TRA_EXPIRE_PERSONNEL_CREDIT_MANUAL:"انقضای اعتبار دستی",
    TRA_EXPIRE_PERSONNEL_CREDIT_SYSTEM:"انقضای اعتبار سیستمی",
    TRA_REMOVE_CORPORATE_PERSONNEL:"حذف پرسنل از شرکت",
    TRA_INCREASE_PERSONNEL_CREDIT_GIFT:"افزایش اعتبار با هدیه",
    TRA_CHECKOUT_BASKET:"فرایند خرید",
    TRA_USE_TICKET:"استفاده بلیط و پرداخت مرکز",
    TRA_USER_WALLETS:"انتقال مبلغ کیف پول",
    TRA_REFUND_TICKET:"عودت بلیط",
    NOT_DEFINE:"تعریف نشده",
}
